import { createAction, props } from '@ngrx/store';
import { ListItem } from 'src/app/shared/models/list-item.model';
import {
    Attachment,
    CandidateOfferClientNote,
    DeclineReasons,
    OfferDetailsRecruiting,
    OfferNotes,
    VendorOptions
} from 'src/app/shared/models/offers.model';
import { OfferMarginDifference } from 'src/app/shared/offers-shared/offer-details/dialog-offer-margin-differences/model/offer-margin-difference.model';

export const getDetails = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Offer Details',
    props<{ id: number }>()
);

export const getDetailsSuccess = createAction(
    '[DEALS API] Load Offer Details Success',
    props<{ details: OfferDetailsRecruiting; difference: OfferMarginDifference[] }>()
);

export const getDetailsFailure = createAction('[DEALS API] Load Offer Details Failure', props<{ error: unknown }>());

export const getAttachments = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Attachments',
    props<{ offerId: number }>()
);

export const getAttachmentsSuccess = createAction(
    '[DEALS API] Load Attachments Success',
    props<{ attachments: Attachment[] }>()
);

export const getAttachmentsFailure = createAction('[DEALS API] Load Attachments Failure', props<{ error: unknown }>());

export const getAttachmentBlob = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Attachment Blob',
    props<{ offerId: number; file: Attachment }>()
);

export const getAttachmentBlobSuccess = createAction(
    '[DEALS API] Load Attachment Blob Success',
    props<{ attachment: Blob; file: Attachment }>()
);

export const getAttachmentBlobFailure = createAction(
    '[DEALS API] Load Attachment Blob Failure',
    props<{ error: unknown }>()
);

export const postAttachment = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Post Attachment',
    props<{ offerId: number; fileToUpload: any }>()
);

export const postAttachmentSuccess = createAction(
    '[DEALS API] Post Attachment Success',
    props<{ id: number; fileName: string }>()
);

export const postAttachmentFailure = createAction('[DEALS API] Post Attachment Failure', props<{ error: unknown }>());

export const updateAttachment = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Update Attachment',
    props<{ offerId: number; attachmentId: number; fileToUpload: any }>()
);

export const updateAttachmentSuccess = createAction(
    '[DEALS API] Update Attachment Success',
    props<{ id: number; fileName: string }>()
);

export const updateAttachmentFailure = createAction(
    '[DEALS API] Update Attachment Failure',
    props<{ error: unknown }>()
);

export const deleteAttachment = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Delete Attachments',
    props<{ offerId: number; id: number }>()
);

export const deleteAttachmentSuccess = createAction('[DEALS API] Delete Attachments Success', props<{ id: number }>());

export const deleteAttachmentFailure = createAction(
    '[DEALS API] Delete Attachments Failure',
    props<{ error: unknown }>()
);

export const declineOffer = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Decline Offer Request',
    props<{ offerId: number; data: any }>()
);

export const declineOfferSuccess = createAction('[DEALS API] Decline Offer Request Success', props<{ id: number }>());

export const declineOfferFailure = createAction(
    '[DEALS API] Decline Offer Request Failure',
    props<{ error: unknown }>()
);

export const getOfferNotes = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Offer Notes',
    props<{ id: number }>()
);

export const getOfferNotesSuccess = createAction(
    '[DEALS API] Load Offer Notes Success',
    props<{ notes: OfferNotes[] }>()
);

export const getOfferNotesFailure = createAction('[DEALS API] Load Offer Notes Failure', props<{ error: unknown }>());

export const postOfferNoteAndNotifyAM = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Add Offer Note And Notify AM',
    props<{ id: number; note: CandidateOfferClientNote }>()
);

export const postOfferNoteAndNotifyAMSuccess = createAction(
    '[DEALS API] Add Offer Note And Notify AM Success',
    props<{ id: number }>()
);

export const postOfferNoteAndNotifyAMFailure = createAction(
    '[DEALS API] Add Offer Note And Notify AM Failure',
    props<{ error: unknown }>()
);

export const getDeclineReasons = createAction('[RECRUITING DEALS DETAILS COMPONENT] Get Decline Reasons');

export const getDeclineReasonsSuccess = createAction(
    '[DEALS API] Get Decline Reasons Success',
    props<{ declineReasons: DeclineReasons[] }>()
);

export const getDeclineReasonsFailure = createAction(
    '[DEALS API] Get Decline Reasons Failure',
    props<{ error: unknown }>()
);

export const vendorSearch = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Vendors for decline dialog',
    props<{ nameSearch: string }>()
);

export const vendorSearchSuccess = createAction(
    '[DEALS SERVICE] Load Vendors Success',
    props<{ vendorSearch: VendorOptions[] }>()
);

export const vendorSearchFailure = createAction('[DEALS SERVICE] Load Vendors Failure', props<{ error: unknown }>());

export const facilitySearch = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Facilities for decline dialog',
    props<{ nameSearch: string }>()
);

export const facilitySearchSuccess = createAction(
    '[DEALS SERVICE] Load Facilities Success',
    props<{ facilitySearch: ListItem[] }>()
);

export const facilitySearchFailure = createAction(
    '[DEALS SERVICE] Load Facilities Failure',
    props<{ error: unknown }>()
);

export const setOfferDetailAsVerballyAccepted = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Set offer as verbally accepted',
    props<{ offerId: number }>()
);
export const setOfferDetailAsVerballyAcceptedSuccess = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Set offer as verbally accepted success',
    props<{ offerId: number }>()
);
export const setOfferDetailAsVerballyAcceptedFailure = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Set offer as verbally accepted failure'
);
